import { Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import MobileSticky from "../components/MobileSticky";
import Seo from "../components/Seo";
import { SUBURBS } from "../data/site";

export default function Suburbs() {
  return (
    <div data-testid="page-suburbs">
      <Seo
        title="Sunshine Coast Painters — Service Areas | Connolly's Painting Solutions"
        description="Premium painting services across the Sunshine Coast. Local crews in Noosa, Coolum, Peregian, Buderim, Maroochydore, Mooloolaba, Caloundra and more."
        path="/suburbs"
      />
      <Header />

      <section className="section bg-[#F9F8F6]">
        <div className="container-cps">
          <div className="overline">Service areas</div>
          <h1 className="font-display text-5xl md:text-7xl mt-4 tracking-tight">Sunshine Coast, end to end.</h1>
          <p className="mt-6 text-[#4F5B6A] max-w-2xl">
            We service the entire Sunshine Coast region. Below are the suburbs we work in most often — click through for local project examples, reviews and FAQs.
          </p>

          <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1 bg-[#E5E3DB]">
            {SUBURBS.map((s) => (
              <Link key={s.slug} to={`/${s.slug}`} className="bg-white p-8 hover:bg-white/80 group" data-testid={`suburbs-card-${s.slug}`}>
                <div className="font-display text-3xl text-[#0B1426] group-hover:text-[#C5A059] transition-colors">{s.name}</div>
                <div className="text-xs uppercase tracking-wider text-[#4F5B6A] mt-2">QLD {s.postcode}</div>
                <p className="text-[#4F5B6A] mt-4 leading-relaxed">{s.blurb}</p>
                <div className="mt-6 text-xs uppercase tracking-[0.18em] text-[#0B1426] group-hover:text-[#C5A059]">View {s.name} →</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <MobileSticky />
    </div>
  );
}
